<header id="header">
  <div class="res-block">
    <div class="logo">
      <img src="../../../../assets/image/Asset4_4xbg-remove.png" alt="PayX" />
    </div>
    <div class="middle-side">
      <span>{{ "deals.title" | translate }}</span>
    </div>
    <div class="main-block">
      <div class="language">
        <div class="am" style="cursor: pointer" (click)="changeLang('am')">
          <img
            src="../../../../assets/image/user-paid-unpaid/armenia.png"
            alt="Armenia"
          />
        </div>
        <div class="ru" style="cursor: pointer" (click)="changeLang('ru')">
          <img
            src="../../../../assets/image/user-paid-unpaid/russia.png"
            alt="Russia"
          />
        </div>
        <div class="en" style="cursor: pointer" (click)="changeLang('en')">
          <img
            src="../../../../assets/image/user-paid-unpaid/united-states.png"
            alt="United States"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="res-block-none">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container-fluid">
        <div class="logo">
          <img src="../../../../assets/image/VTB/VTB_logo.jpg" alt="PayX">
        </div>
        <div class="middle-side">
          <span>{{'deals.title' | translate}}</span>
        </div>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <div class="main-block">
            <div class="language">
              <div class="am" style="cursor: pointer;" (click)="changeLang('am')">
                <img src="../../../../assets/image/user-paid-unpaid/armenia.png" alt="Armenia">
              </div>
              <div class="ru" style="cursor: pointer;" (click)="changeLang('ru')">
                <img src="../../../../assets/image/user-paid-unpaid/russia.png" alt="Russia">
              </div>
              <div class="en" style="cursor: pointer;" (click)="changeLang('en')">
                <img src="../../../../assets/image/user-paid-unpaid/united-states.png" alt="United States">
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div> -->
</header>
